import * as THREE from 'three';

import Store from './Store';
import { NavigationPoint } from './components/NavigationPoints';


export default class EventManager {
  constructor() {
    const { app, canvas } = Store.getState();
    this.mouseDownPos = new THREE.Vector2();
    this.mouseUpPos = new THREE.Vector2();

    // Attach event listeners
    window.addEventListener('wheel', this.onCanvasScroll.bind(this));
    window.addEventListener('keydown', this.handleKeydown.bind(this));

    // ui
    document.getElementById("view-mode-button").addEventListener('click', app.cameraHandlers.toggleViewMode.bind(app.cameraHandlers));
    document.getElementById("full-screen-button").addEventListener('click', this.handleFullscreenToggle.bind(this));
    document.getElementById("guide-toggle-button").addEventListener('click', this.handleGuideToggle.bind(this));
    document.getElementById("free-explore-toggle-button").addEventListener('click', this.handleGuideToggle.bind(this));


    // pointer events
    canvas.addEventListener('mousemove', app.pointerHandlers.handleMouseMove.bind(app.pointerHandlers));
    document.addEventListener('mousedown', this.handleMouseDown.bind(this));
    document.addEventListener('mouseup', this.handleMouseUp.bind(this));
  }

  handleKeydown(event) {
    switch(event.key) {
      case '\\':
        this.toggleDebugMode();
        break;
    }
  }

  handleMouseDown(event) {
    this.mouseDownPos.x = event.clientX;
    this.mouseDownPos.y = event.clientY;
  }

  handleMouseUp(event) {
    const { app, viewMode } = Store.getState();
    
    this.mouseUpPos.x = event.clientX;
    this.mouseUpPos.y = event.clientY;

    const dx = this.mouseUpPos.x - this.mouseDownPos.x;
    const dy = this.mouseUpPos.y - this.mouseDownPos.y;

    if (Math.abs(dx) < 5 && Math.abs(dy) < 5) { // Threshold to consider as a click, adjust as needed
      app.pointerHandlers.handleClick(event);
    }
  }

  onCanvasScroll(event) {
    const { app, viewMode } = Store.getState();
    

    if (viewMode === "FPV") {
      const direction = event.deltaY > 0 ? -1 : 1;
      const zoomSpeed = 10;

      app.cameraHandlers.handleZoom(direction * zoomSpeed);
    }
  }


  toggleDebugMode() {
    const { debugMode, app } = Store.getState();
    Store.setState({ debugMode: !debugMode });

    app.dollhouse.handleToggleDebugMode();
    app.navPoints.handleToggleDebugMode();
    app.envCube.handleToggleDebugMode();
    app.debugInfo.handleToggleDebugMode();
  }


  handleFullscreenToggle() {
    // Check if the document is currently in fullscreen mode
    const isFullscreen = document.fullscreenElement || 
                          document.mozFullScreenElement || 
                          document.webkitFullscreenElement || 
                          document.msFullscreenElement;

    const fullscreenOnSVG = document.getElementById("full-screen-on");
    const fullscreenOffSVG = document.getElementById("full-screen-off");
    if (isFullscreen) {
      fullscreenOnSVG.classList.remove("hidden");
      fullscreenOffSVG.classList.add("hidden");
    } else {
      fullscreenOnSVG.classList.add("hidden");
      fullscreenOffSVG.classList.remove("hidden");
    }

    // Exit fullscreen mode if currently in fullscreen mode
    if (isFullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
    } else { // Otherwise, enter fullscreen mode
      const elem = document.documentElement;

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    }

  }

  handleGuideToggle() {
    const { app, tourGuidedMode } = Store.getState();

    const tourUI = document.getElementById("tour-ui");
    const guideToggleButton = document.getElementById("guide-toggle-button");
    const freeExploreToggleButton = document.getElementById("free-explore-toggle-button");

    if (tourGuidedMode) {
      tourUI.classList.add("hidden")
      app.sceneGraph.hideAllModels();
      app.setLightIntensity(1.6);
      app.rig.flashlight.hide();

      guideToggleButton.classList.add("hidden");
      freeExploreToggleButton.classList.remove("hidden");

    } else {
      tourUI.classList.remove("hidden")
      app.setLightIntensity(1);
      app.rig.flashlight.show();

      guideToggleButton.classList.remove("hidden");
      freeExploreToggleButton.classList.add("hidden");

    }

    Store.setState({ tourGuidedMode: !tourGuidedMode });
  }
}


